import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutdpLicense extends Layout {
    textboxLicUsed: Textbox;
    textboxTotLics: Textbox;
}
